import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary,
  primary
} from '../../../style';
import { getAllInfluencerTags } from '../../../store/selectors/tags';
import { getActiveCampaigns } from '../../../store/selectors/campaigns';
import {
  getDealsByCampaignId,
  getDealList
} from '../../../store/selectors/deals';
import { CompanyInterestedFromDashboard } from '../../../store/actions/dealActions';
import {
  showAlreadyMatchedNotification,
  showNoActiveCampaignsNotification
} from '../../../store/actions/notificationsActions';

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '500px'
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  header: {
    marginBottom: '15px',
    paddingTop: theme.spacing.unit * 7
  },
  title: {
    color: deepPurple
  },
  listRow: {
    padding: 24,
    borderBottom: '1px solid #c5c5c5',
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    },
    '&:nth-first-child': {
      paddingTop: 0
    },
    '&:nth-last-child': {
      paddingBottom: 30,
      borderBottom: 'none'
    }
  },
  descriptionContainer: {
    marginTop: '30px',
    maxHeight: '100px',
    overflow: 'hidden'
  },
  interestContainer: {
    marginTop: '15px'
  },
  interest: {
    marginRight: '13px',
    borderRadius: '10px',
    background: grey,
    padding: '7px'
  },
  downArrow: {
    display: 'block',
    margin: '0 auto'
  },
  loadMoreTextContainer: {
    marginTop: '20px'
  },
  companyImage: {
    height: '70px',
    borderRadius: '100px'
  },
  icon: {
    color: 'red',
    width: '25px',
    height: '25px'
  },
  space: {
    marginTop: '30px',
    marginBottom: '30px'
  },
  search: {
    background: 'white',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '10px'
  },
  searchInput: {
    width: '100%'
  },
  reactAutosuggestContainer: {
    position: 'relative',
    width: '100%',
    border: 'none',
    height: '50px',
    background: 'white'
  },
  reactAutosuggestInput: {
    width: '100%',
    height: '50px',
    padding: '10px 20px',
    border: 'none',
    backgroundColor: 'white'
  },
  reactAutosuggestInputFocused: {
    outline: 'none'
  },
  reactAutosuggestInputOpen: {
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0'
  },
  reactAutosuggestSuggestionsContainer: {
    display: 'none'
  },
  reactAutosuggestSuggestionsContainerOpen: {
    display: 'block',
    position: 'absolute',
    top: '51px',
    width: '100%',
    border: '1px solid #aaa',
    backgroundColor: '#fff',
    fontSize: '16px',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    zIndex: '2',
    maxHeight: '400px',
    overflowY: 'scroll'
  },
  reactAutosuggestSuggestionsList: {
    margin: '0',
    padding: '0',
    listStyleType: 'none'
  },
  ReactAutosuggestSuggestion: {
    cursor: 'pointer',
    padding: '10px 20px'
  },
  reactAutosuggestSuggestionHighlighted: {
    backgroundColor: '#ddd'
  },
  searchBox: {
    background: 'white'
  },
  filterButton: {
    minWidth: '131px',
    background: text__primary,
    color: white,
    '&:hover': {
      background: text__primary_dark
    }
  },
  searchButton: {
    minWidth: '131px',
    background: '#22c26e',
    color: white
    // '&:hover': {
    //   background: text__primary_dark
    // }
  },
  filterButton: {
    minWidth: '131px',
    background: text__primary,
    color: white,
    '&:hover': {
      background: text__primary_dark
    }
  },
  applyFilterButton: {
    color: white,
    marginLeft: '20px'
  },
  expandPanel: {
    boxShadow: 'none',
    background: '#F8F8F8'
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  select: {
    width: '250px',
    marginTop: '0px',
    background: 'white',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  starRatings: {
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      textAlign: 'right'
    }
  },
  youtubeStats: {
    // color: primary
  },
  youtubeIcon: {
    color: 'red',
    width: '15px',
    height: '15px',
    color: white
  },
  youtubeContainer: {
    marginTop: '15px'
  },
  youtubeStatTitle: {
    marginLeft: '15px'
  },
  youtubeStat: {
    fontWeight: '900'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '96px',
    height: '96px'
  },
  loadMoreText: {
    color: '#22c26e',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  matchButton: {
    color: '#ffffff',
    minWidth: '131px',
    background: '#22c26e'
  },
  filterToolbar: {
    background: '#F8F8F8'
  },
  pictureLink: {
    cursor: 'pointer'
  },
  input1: {
    height: '2px'
  },
  selectRoot: {
    height: 40,
    display: 'flex'
  },
  select2: {
    height: 40,
    paddingTop: 0,
    paddingBottom: 0,
    alignItems: 'center'
  },
  creatorFiltersRow: {
    marginTop: '20px'
  }
});

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    influencerTags: getAllInfluencerTags(state),
    activeCampaigns: getActiveCampaigns(state),
    deals: ownProps.campaign
      ? getDealsByCampaignId(ownProps.campaign.id)(state)
      : getDealList(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    CompanyMatchRequestHandler: (influencerId, companyId, campaignId) =>
      dispatch(
        CompanyInterestedFromDashboard(influencerId, companyId, campaignId)
      ),
    showAlreadyMatchedNotification: () =>
      dispatch(showAlreadyMatchedNotification()),
    showNoActiveCampaignsNotification: () =>
      dispatch(showNoActiveCampaignsNotification())
  };
};

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles),
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/company/discover-influencers/InfluencerList.enhancer.js